export default __webpack_public_path__ + "static/media/tab-connect-participant-detail.32be785d.png";